var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-leilao-container"},[_vm._v(" Módulo em processo de atualização, consulte seu gerente de contas para verificar o andamento da ativação. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }